var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit_frame" },
    [
      _c("common_edit"),
      _c("div", { staticClass: "title mb-12" }, [_vm._v("样式")]),
      _c("my_opacity", {
        attrs: { value: _vm.module.style.opacity, title: "透明度" },
        on: {
          "update:value": function ($event) {
            return _vm.$set(_vm.module.style, "opacity", $event)
          },
        },
      }),
      _vm.module.imgType != "qrCode"
        ? _c("my_radius", {
            attrs: { value: _vm.module.style["border-radius"], title: "圆角" },
            on: {
              "update:value": function ($event) {
                return _vm.$set(_vm.module.style, "border-radius", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }